import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeo } from './applySeo.mjs';
import settings from './pages.json';

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => { applySeo(document, pathname, settings); }, [pathname]);
  return null;
}
